import { useDispatch } from 'react-redux';
import { FilterValuesStrings } from '../pages/analytics.page';
import { useAnalyticsFilterSelector, setFilters, clearFilters } from '../store/analytics-filters.slice';

export const useAnalyticsFilters = () => {
	const dispatch = useDispatch();
	const { filters } = useAnalyticsFilterSelector();

	const setAnalyticsFilters = (newFilters: FilterValuesStrings) => {
		dispatch(setFilters(newFilters));
	};

	const clearAnalyticsFilters = () => {
		dispatch(clearFilters());
	};

	return {
		filters,
		setAnalyticsFilters,
		clearAnalyticsFilters,
	};
};
